import React from "react";
import "./Our_Clients.css";
import Header_Banner from "../common-components/common_banner/header_banner/Header_Banner";
import Complete_Medical from "../common-components/common_banner/complete_medical/Complete_Medical";
import { Col, Container, Row } from "react-bootstrap";

const Our_Clients = () => {
  const Clients = [
    {
      img: "/assets/images/our_clients/image-1.png",
    },
    {
      img: "/assets/images/our_clients/image-2.png",
    },
    {
      img: "/assets/images/our_clients/image-3.png",
    },
    {
      img: "/assets/images/our_clients/image-4.png",
    },
    {
      img: "/assets/images/our_clients/image-5.png",
    },
    {
      img: "/assets/images/our_clients/image-6.png",
    },
    {
      img: "/assets/images/our_clients/image-7.png",
    },
    {
      img: "/assets/images/our_clients/image-8.png",
    },
    {
      img: "/assets/images/our_clients/image-9.png",
    },
    
    {
      img: "/assets/images/our_clients/image-10.png",
    },
    {
      img: "/assets/images/our_clients/image-11.png",
    },
    {
      img: "/assets/images/our_clients/image-12.png",
    },
    {
      img: "/assets/images/our_clients/image-13.png",
    },
    {
      img: "/assets/images/our_clients/image-14.png",
    },
    {
      img: "/assets/images/our_clients/image-15.png",
    },
    {
      img: "/assets/images/our_clients/image-16.png",
    },
    {
      img: "/assets/images/our_clients/image-17.png",
    },
    {
      img: "/assets/images/our_clients/image-18.png",
    },
    {
      img: "/assets/images/our_clients/image-19.png",
    },
    {
      img: "/assets/images/our_clients/image-20.png",
    },
    {
      img: "/assets/images/our_clients/image-21.png",
    },
    {
      img: "/assets/images/our_clients/image-22.png",
    },
    {
      img: "/assets/images/our_clients/image-23.png",
    },
    {
      img: "/assets/images/our_clients/image-24.png",
    },
    {
      img: "/assets/images/our_clients/image-25.png",
    },
    {
      img: "/assets/images/our_clients/image-26.png",
    },
    {
      img: "/assets/images/our_clients/image-27.png",
    },
  ];
  const breadcrumbs = [
    { label: "Home", link: "/about-us", isActive: false },
    { label: "OUR CLIENTS", link: "", isActive: true },
  ];
  return (
    <section className="our_clients_section">
      <Header_Banner
        imgSrc={"assets/images/about_us/healthcare-banner.png"}
        title_text="Our Clients"
        breadcrumbs={breadcrumbs}
      />
      <Container>
        <div className="clients_image_col">
          <Row className="align-items-center mb-4">
            {Clients.map((items, index) => (
              <Col lg={2} md={3} sm={3} xs={4}  key={index} className="mb-4">
                <div className="clients_img_holder">
                  <img
                    src={items.img}
                    className="clients_logo"
                    alt="clients-logo"
                  />
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>

      <Complete_Medical />
    </section>
  );
};

export default Our_Clients;
